import { useReducer } from 'react';

export const useForceUpdate = () => {
  const [state, increment] = useReducer((counter) => counter++, 0);

  return [increment, state] as const;
};
